import * as yup from "yup";

export const createValidationSchema = () => {
    return yup.object().shape({
        tournamentName: yup.string(),
        player1: yup.string().required("Player 1 is required"),
        player2: yup.string().required("Player 2 is required"),
        group: yup.number().required("Group is required"),
        location: yup.string().required("Location is required"),
        type: yup.number(),
        isValid: yup
            .string()
            .test("match", "You cannot select the same players", function () {
                return this.parent.player1 !== this.parent.player2 ||
                    !this.parent.player1?.trim() ||
                    !this.parent.player2?.trim();
            }),
    }).test("tournament-or-type", "Either tournament or type must be selected", function (value) {
        const hasTournament = !!value.tournamentName?.trim();
        const hasType = value.type !== null && value.type !== undefined;
        if (!hasTournament && !hasType) {
            return this.createError({
                path: "tournamentName",
                message: "Either tournament or type must be selected",
            });
        }
        return true;
    });
};
